import { createFileRoute, useParams } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitSettingsPage } from '@/loaders/unit.settings.loader';
import NetworkSettings from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/_components/NetworkSettings';
import UnitSettings from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/_components/UnitSettings';

export function UnitSettingsPage() {
  const { endCustomerUnitId } = useParams({
    strict: false,
  });

  if (!endCustomerUnitId) {
    return <></>;
  }

  return (
    <div className="flex flex-col gap-6">
      <UnitSettings endCustomerUnitId={endCustomerUnitId} />
      <NetworkSettings />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/')({
  component: UnitSettingsPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitSettingsPage,
});
